import React, { useState } from "react";
import { Theme } from "../../../../providers/ThemeProvider";
import SearchIcon from "../../svg/SearchIcon";

const ServiceSearchBar = ({
  serviceFilter,
  setServiceFilter,
  theme,
}: {
  serviceFilter: string;
  setServiceFilter: (filter: string) => void;
  theme: Theme;
}) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div style={styles.searchContainer(theme, isFocused)}>
      {isFocused || serviceFilter !== "" ? (
        <label style={styles.searchLabel(theme)}>Search services</label>
      ) : (
        <div style={styles.searchIcon}>
          <SearchIcon fill={theme.colors_ds.NEUTRAL_ICON_WEAK} />
        </div>
      )}
      <input
        type="text"
        style={{
          ...styles.searchInput(theme),
          paddingLeft: isFocused || serviceFilter !== "" ? "12px" : "40px", // Adjust padding based on focus
          paddingTop: isFocused || serviceFilter !== "" ? "24px" : "16px", // Space for label when focused
          paddingBottom: isFocused || serviceFilter !== "" ? "8px" : "16px", // Maintain consistent total vertical padding (24px + 8px = 32px)
        }}
        value={serviceFilter}
        onChange={(e) => setServiceFilter(e.target.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        placeholder="Search services"
      />
    </div>
  );
};

const styles = {
  searchContainer: (theme: any, isFocused: boolean) => ({
    position: "relative" as "relative",
    height: "56px",
    border: `1px solid ${
      isFocused
        ? theme.colors_ds.PRIMARY_ICON_MAIN
        : theme.colors_ds.NEUTRAL_BORDER_WEAK
    }`,
    borderRadius: "8px",
    backgroundColor: theme.colors_ds.NEUTRAL_GENERAL_WHITE,
    transition: "border-color 0.2s ease",
  }),
  searchIcon: {
    position: "absolute" as "absolute",
    left: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 1,
  },
  searchLabel: (theme: any) => ({
    position: "absolute" as "absolute",
    top: "6px",
    left: "12px",
    fontSize: "10px",
    fontFamily: "var(--font-Medium)",
    color: theme.colors_ds.PRIMARY_ICON_MAIN,
    zIndex: 1,
    pointerEvents: "none" as "none",
  }),
  searchInput: (theme: any) => ({
    width: "100%",
    height: "100%",
    border: "none",
    outline: "none",
    padding: "16px 12px",
    paddingLeft: "40px", // Space for icon when not focused
    borderRadius: "8px",
    fontSize: "12px",
    fontFamily: "var(--font-Medium)",
    color: theme.colors_ds.NEUTRAL_TEXT_DEFAULT,
    backgroundColor: "transparent",
    caretColor: theme.colors_ds.PRIMARY_ICON_MAIN,
    "&::placeholder": {
      color: theme.colors_ds.NEUTRAL_TEXT_WEAK,
    },
  }),
};

export default ServiceSearchBar;
